import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Card from "@/globalComponents/atoms/Card"
import Heading from "@/globalComponents/atoms/Heading"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/_authenticated/account/keys-and-memberships"
)({
  staticData: {
    pageName: "Keys & Memberships",
  },
  loader: () => ({
    crumb: { translationKey: "common:keysAndMemberships.header" } as Crumb,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation(["common"])

  return (
    <Card>
      <Heading level={2}>{t("keysAndMemberships.header")}</Heading>
    </Card>
  )
}
